import { render } from "./TextEditor.vue?vue&type=template&id=4d02f972&scoped=true&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=4d02f972&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d02f972"]])

export default __exports__